/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsumptionForProductionOrderViewModel } from '../../models/consumption-for-production-order-view-model';
import { MaterialType } from '../../models/material-type';

export interface GetConsumptionForProductionOrder$Params {
  productionOrderId: number;
  materialType: MaterialType;
  runId?: number;
}

export function getConsumptionForProductionOrder(http: HttpClient, rootUrl: string, params: GetConsumptionForProductionOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsumptionForProductionOrderViewModel>> {
  const rb = new RequestBuilder(rootUrl, getConsumptionForProductionOrder.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.path('materialType', params.materialType, {});
    rb.query('runId', params.runId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsumptionForProductionOrderViewModel>;
    })
  );
}

getConsumptionForProductionOrder.PATH = '/api/v1/ProductionOrder/{productionOrderId}/Consumptions/{materialType}';
